export default __webpack_public_path__ + "static/timberline-hero-image-new-463db51809bb90e91f9b48afaebf0d1d.jpg";